<template>
    <div class="left_panel">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading accessdenie">
                <!-- <h2>Access Denied 403</h2> -->
                <div class="subhead">
                    <p>Here is a no page access to user account</p>
                    <p>Please go to home page</p>
                    <router-link :to="{ name: 'home' }"
                        >Back to home page</router-link
                    >
                </div>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <div
                    v-if="savedDesigns.length > 0"
                    class="select_checkbox form-check pl_8 py_6"
                >
                    <label class="checkbox_custom font_size_20">
                        Select All
                        <input
                            type="checkbox"
                            @click="selectAll"
                            v-model="allSelected"
                        />
                        <span class="checkmark"></span>
                    </label>
                </div>

                <div
                    v-if="designIds.length > 0"
                    @click="deletesavedDesigns()"
                    class="delet_icon"
                >
                    <span class="bin_icon">
                        <img alt src="/maincss/images/icons/delete_dark.svg" />
                    </span>
                    <span class="font_size_20">Delete</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { fabric } from "fabric";
import ApiService from "@/common/api.service";
import { LOGOUT } from "@/store/actions.type";

export default {
    name: "AccessDenied",
    data() {
        return {
            savedDesigns: [],
            allSelected: false,
            designIds: [],
            gender_count: 0,
            genders: [],
            user_selected_values: [],
            active_gender: "",
            active_gender_key: 0,
            canvas_elements: [],
            deleteIcon: true
        };
    },
    components: {},
    beforeMount() {
        this.getData();
    },
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    },
    methods: {
        getData() {
            //get saved designs
            ApiService.post("/savedDesigns")
                .then(({ data }) => {
                    this.savedDesigns = data.savedDesigns;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
        },
        selectAll: function () {
            this.designIds = [];

            if (!this.allSelected) {
                for (var design in this.savedDesigns) {
                    this.designIds.push(
                        this.savedDesigns[design].id.toString()
                    );
                }
            }
        },
        select: function (event, design_id) {
            this.allSelected = false;
            if (!event.target.checked) {
                const index = this.designIds.indexOf(design_id);
                if (index > -1) {
                    this.designIds.splice(index, 1);
                }
            } else {
                this.designIds.push(design_id.toString());
            }
            if (this.savedDesigns.length == this.designIds.length) {
                this.allSelected = true;
            }
        },
        deleteDesign(design_id) {
            this.designIds.push(design_id.toString());
            this.deletesavedDesigns();
        },
        deletesavedDesigns() {
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ApiService.post("/delete_saveddesigns", {
                        ids: this.designIds
                    })
                        .then(() => {
                            this.$toast.success(
                                "Designs deleted successfully",
                                {
                                    position: "top-right"
                                }
                            );
                            this.designIds = [];
                            this.getData();
                        })
                        .catch(() => {});
                });
            }
        },
        setDesign(saved_design) {
            var canvas = new fabric.Canvas("tcanvas", {
                hoverCursor: "pointer",
                selection: true,
                selectionBorderColor: "blue"
            });
            //set canvas objects while selecting design
            this.canvas_elements = "";
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            let product_details = saved_design.product_details;
            let values = [];
            this.user_selected_values = [];
            this.product_title = saved_design["product_title"];
            this.product_id = saved_design.id;
            this.design_name = saved_design.design_name;
            this.base_price = saved_design.retail_base_price;
            let gender = product_details[0].gender;
            let pro_value = new Array();
            pro_value.push({
                product_title: saved_design["product_title"],
                product_id: saved_design.id,
                design_name: saved_design.design_name,
                base_price: saved_design.retail_base_price,
                product_details: saved_design
            });
            product_details.forEach((element) => {
                values.push({
                    [element.gender]: JSON.parse(element.canvas_objects)
                });
                this.genders.push(element.gender);
                this.user_selected_values.push({
                    color: element.color_name,
                    color_hash: element.color_hash,
                    qty: element.qty,
                    total_cost: element.total_cost,
                    total_qty: element.total_qty,
                    gender: element.gender
                });
            });
            localStorage.setItem("product_values", JSON.stringify(pro_value));
            localStorage.setItem(
                "user_selected_values",
                JSON.stringify(this.user_selected_values)
            );
            this.canvas_elements = values;
            localStorage.setItem(
                "canvas_elements",
                JSON.stringify(this.canvas_elements)
            );
            this.active_gender = gender;
            this.active_gender_key = 0;
            localStorage.setItem("active_gender", gender);
            localStorage.setItem("active_gender_key", 0);
            if (
                this.canvas_elements[this.active_gender_key][this.active_gender]
                    .length > 0
            ) {
                this.canvas_elements[this.active_gender_key][
                    this.active_gender
                ].forEach((element) => {
                    if (
                        element.type == "template" ||
                        element.type == "shape" ||
                        element.type == "patch" ||
                        element.type == "upload"
                    ) {
                        if (
                            element.flip == localStorage.getItem("active_flip")
                        ) {
                            fabric.Image.fromURL(
                                element.url,
                                function (image) {
                                    image.set({
                                        id: element.id,
                                        left: element.left,
                                        top: element.top,
                                        angle: element.angle,
                                        padding: element.padding,
                                        cornersize: element.cornersize,
                                        hasRotatingPoint: true
                                    });

                                    canvas.add(image);
                                },
                                null,
                                { crossOrigin: "Anonymous" }
                            );
                        }
                    }
                });
            }
            window.location.href = "/design-studio";
        },
        logout() {
            var _this = this;
            this.$store.dispatch(LOGOUT).then(() => {
                _this.$toast.success("Logout Successfully", {
                    position: "top-right"
                });
                this.$router.push({ path: "/" });
            });
        }
    }
};
</script>
